import { Component, Input, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pl-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalErrorComponent {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);

  @Input({ required: true }) public title!: string;
  @Input({ required: true }) public description!: string;

  public close(): void {
    this.activeModal.dismiss();
  }
}
